import apiClient from './client';

export interface VendorProduct {
  vendorKey: string;
  sku: string;
  vendorName: string;
  /** Commercial name of this vendor's variant (e.g. Cotality's AVMs: GEOAVM, THV, HVE1). */
  vendorProductName?: string;
  price: number;
  maxEtaDays: number;
  isPreferred: boolean;
  isOrderCancelEnabled: boolean;
  urn: string;
  metadata?: {
    schemas?: { deliverables?: { properties?: Record<string, unknown> } };
  };
}

export interface Product {
  urn: string;
  uuid: string;
  productName: string;
  serviceType: string;
  processType: string;
  productType: string;
  methodOfDelivery: string;
  description: string;
  price: number;
  maxEtaDays: number;
  upc: string;
  vendorProducts: VendorProduct[];
  creationDate: string;
  modificationDate: string;
}

export interface UpdateProductRequest {
  productName?: string;
  description?: string;
  price?: number;
  maxEtaDays?: number;
  [key: string]: unknown;
}

export interface UpdateVendorProductRequest {
  vendorKey?: string;
  sku?: string;
  vendorName?: string;
  price?: number;
  maxEtaDays?: number;
  isPreferred?: boolean;
  isOrderCancelEnabled?: boolean;
  [key: string]: unknown;
}

export async function getProducts(): Promise<Product[]> {
  const response = await apiClient.get('/oms/catalogs');
  return response.data;
}

export async function getProduct(id: string): Promise<Product> {
  const response = await apiClient.get(`/oms/catalogs/${id}`);
  return response.data;
}

export async function updateProduct(id: string, data: UpdateProductRequest): Promise<Product> {
  const response = await apiClient.patch(`/oms/catalogs/${id}`, data);
  return response.data;
}

export async function updateVendorProduct(
  upc: string,
  sku: string,
  data: UpdateVendorProductRequest,
): Promise<VendorProduct> {
  const response = await apiClient.patch(`/oms/catalogs/${upc}/vendor-products/${sku}`, data);
  return response.data;
}

export async function getProductSuggestions(params: Record<string, unknown>): Promise<unknown[]> {
  const response = await apiClient.post('/oms/catalogs/suggestions', params);
  return response.data;
}
